
import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        map: '[js-google-map="map"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.map) && !document.querySelector(nodeSelectors.map+' .marker')) {
            return
        }

        // Render maps on page load.
        $(document).ready(function(){
            $(nodeSelectors.map).each(function(){
                let map = initMap( $(this) );
            });
        })
    }

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap( $el ) {

        // Find marker elements within map.
        var $markers = $el.find('.marker');

        // Create gerenic map.
        var mapArgs = {
            zoom        : $el.data('zoom') || 16,
            mapTypeId   : google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#223024"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f2efe5"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#729b70"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ]
        };
        var map = new google.maps.Map( $el[0], mapArgs );

        // Add markers.
        map.markers = [];
        $markers.each(function(){
            initMarker( $(this), map );
        });

        // Center map based on markers.
        centerMap( map );

        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map ) {
        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');

        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };

        // Create marker instance.
        var marker = new google.maps.Marker({
            position : latLng,
            map: map,
            url: 'https://maps.app.goo.gl/so7zWL78i5Pibstp7',
            // icon: siteData.theme_url + '/src/images/icons/pin.svg',
            icon: {
                url: siteData.theme_url + '/src/images/icons/pin.svg',
                scaledSize: new google.maps.Size(100, 50), // scaled size
                // origin: new google.maps.Point(50,50), // origin
                // anchor: new google.maps.Point(-1,-1) // anchor
            },
        });

        // Append to reference for later use.
        map.markers.push( marker );

        google.maps.event.addListener(marker, 'click', function() {
            window.open(this.url, '_blank');
        });

        // If marker contains HTML, add it to an infoWindow.
        // if( $marker.html() ){

            // Create info window.
            // var infowindow = new google.maps.InfoWindow({
            //     content: $marker.html()
            // });

            // // Show info window when marker is clicked.
            // google.maps.event.addListener(marker, 'click', function() {
            //     infowindow.open( map, marker );
            // });
            //
            // infowindow.open( map, marker );
        // }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap( map ) {
        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );

            // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }

    return Object.freeze({
        init,
    })
}